import { render, staticRenderFns } from "./newly-registered-report.vue?vue&type=template&id=c0999132"
import script from "./newly-registered-report.vue?vue&type=script&lang=js"
export * from "./newly-registered-report.vue?vue&type=script&lang=js"
import style0 from "./newly-registered-report.vue?vue&type=style&index=0&id=c0999132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports